<template>
  <div class="view-album-container">
    <div v-if="loading">Loading...</div>
    <div v-if="loadingError">There was an error: {{loadingError.message}}</div>
    <div v-if="album">
      <ViewAlbum :album="album" :user="user" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Header from './Header'
import ViewAlbum from './ViewAlbum'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      album: null,
      loading: false,
      loadingError: null,
    }
  },
  mounted() {
    this.loading = true
    axios.get('/api/albums/' + this.id).then(response => {
      this.album = response.data.album
    }).catch(error => {
      this.loadingError = error.response ? error.response.data : error
    }).then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
  },
  components: {
    Header,
    ViewAlbum,
  },
}
</script>

<style lang="stylus" scoped>

</style>
